// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Menu_V2_Types_MenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var EnabledMenuConsumers = function (x) {
    return x;
};
var newtypeEnabledMenuConsume = {
    Coercible0: function () {
        return undefined;
    }
};
var eqEnabledMenuConsumers = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Set_Serialized.eqSet(Restaumatic_Menu_V2_Types_MenuConsumer.eqMenuConsumer)))(x)(y);
        };
    }
};
var genericEnabledMenuConsumers = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showEnabledMenuConsumers = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericEnabledMenuConsumers)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ Data_Set_Serialized.showSet(Restaumatic_Menu_V2_Types_MenuConsumer.showMenuConsumer))))({
        reflectSymbol: function () {
            return "EnabledMenuConsumers";
        }
    }))
};
var unscrambleDecodeEnabledMenuConsumers = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericEnabledMenuConsumers)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeMaybe(/* #__PURE__ */ Data_Set_Serialized.udecodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.ordMenuConsumer)(Restaumatic_Menu_V2_Types_MenuConsumer.unscrambleDecodeMenuConsumer)))))(Unscramble_Generic.defaultOptions)
};
var encodeEnabledMenuConsumers = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericEnabledMenuConsumers)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "EnabledMenuConsumers";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(/* #__PURE__ */ Data_Set_Serialized.encodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.encodeMenuConsumer))))))
};
var decodeEnabledMenuConsumers = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericEnabledMenuConsumers)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "EnabledMenuConsumers";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(/* #__PURE__ */ Data_Set_Serialized.decodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.ordMenuConsumer)(Restaumatic_Menu_V2_Types_MenuConsumer.decodeMenuConsumer)))))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    EnabledMenuConsumers,
    genericEnabledMenuConsumers,
    eqEnabledMenuConsumers,
    showEnabledMenuConsumers,
    encodeEnabledMenuConsumers,
    decodeEnabledMenuConsumers,
    unscrambleDecodeEnabledMenuConsumers,
    newtypeEnabledMenuConsume
};
//# sourceMappingURL=index.js.map
